export default __webpack_public_path__ + "cb217b6cb224f9a6f79ca5a9fb3197bd.svg";